'use strict';
import { debounce, isPhablet, isTablet } from '../../../_js/_helper';


export default class TimelineNew {
  constructor() {





    var timeline_json ={

"events": [
{
"start_date": {
"month": "1",
"year": "2010"
},
"text": {
"headline": "<p class='timeline-month'>January</p><p class='timeline-year'>2018<p>",
"text": "<p>Raine Square will include new access points for pedestrians to move throughout the precinct with ease and will create a natural route for commuters, shoppers and pedestrians accessing the new bus terminus and train station.</p>"
}
},
{

"start_date": {
  "month": "3",
"year": "2018"
},
"text": {
"headline": "<p class='timeline-month'>March</p><p class='timeline-year'>2018<p>",
"text": "<p>Raine Square will include new access points for pedestrians to move throughout the precinct with ease and will create a natural route for commuters, shoppers and pedestrians accessing the new bus terminus and train station.</p>"
}
},
{

"start_date": {
  "month": "10",
"year": "2018"
},
"text": {
"headline": "<p class='timeline-month'>October</p><p class='timeline-year'>2018<p>",
"text": "<p>Raine Square will include new access points for pedestrians to move throughout the precinct with ease and will create a natural route for commuters, shoppers and pedestrians accessing the new bus terminus and train station.</p>"
}
},
{

"start_date": {
  "month": "12",
"year": "2018"
},
"text": {
"headline": "<p class='timeline-month'>December</p><p class='timeline-year'>2018<p>",
"text": "<p>Raine Square will include new access points for pedestrians to move throughout the precinct with ease and will create a natural route for commuters, shoppers and pedestrians accessing the new bus terminus and train station.</p>"
}
},

{

"start_date": {
  "month": "1",
"year": "2019"
},
"text": {
"headline": "<p class='timeline-month'>January</p><p class='timeline-year'>2019<p>",
"text": "<p>Raine Square will include new access points for pedestrians to move throughout the precinct with ease</p>"
}
},
]
}



      var options={
        scale_factor: 2,
        start_at_end: true,
        zoom_factor: 2
      };

      if($(window).width() < 600){
          options = {
            scale_factor: 4,
            start_at_end: true,
            zoom_factor: 4

          }
      }else if($(window).width() < 767){
        options = {
          scale_factor: 2,
          start_at_end: true,
          zoom_factor: 2
        }

      }else if($(window).width() < 980){
          options = {
            scale_factor: 2,
            start_at_end: true,
            zoom_factor: 2
          }

      }else if($(window).width() < 1880){
          options = {
            scale_factor: 1,
            start_at_end: true,
            zoom_factor: 1
          }
      }

      if($('#timeline-embed').length){
            window.timeline = new TL.Timeline('timeline-embed', timeline_json, options);
      }

      $(window).on('resize', debounce(function () {
        var options;
        if($('#timeline-embed').length){
          if($(window).width() < 600){
              options = {
                scale_factor: 0.5,

              }
          }else if($(window).width() < 767){
            options = {
              scale_factor: 0.5,
            }

          }else if($(window).width() < 980){
              options = {
                scale_factor: 1,
              }
          }else if($(window).width() < 1880){
              options = {
                scale_factor: 2,
              }
          }else{
            options = {
              scale_factor: 1,
            }
          }

              window.timeline = new TL.Timeline('timeline-embed', timeline_json, options);
            }

      }, 250));

//drag inside of div
$.fn.attachDragger = function(){
    var attachment = false, lastPosition, position, difference;
    var attachAndMove = false;
    $( $(this).selector ).on("mousedown mouseup mousemove dragend",function(e){

        if( e.type == "mousedown" && $(e.target).hasClass('timeline__list')){
          attachment = true, lastPosition = [e.clientX, e.clientY];
        }

        if( (e.type == "mouseup" || e.type == "dragend") && $(e.target).hasClass('timeline__list')){
          attachment = false;
        }

        if( e.type == "mousemove" && attachment == true && $(e.target).hasClass('timeline__list')){
            position = [e.clientX, e.clientY];
            difference = [ (position[0]-lastPosition[0]), (position[1]-lastPosition[1]) ];
            $(this).scrollLeft( $(this).scrollLeft() - difference[0]);
            lastPosition = [e.clientX, e.clientY];
        }
    });
    $(window).on("mouseup", function(){
        attachment = false;
    });
}
let that = this;
$(document).ready(function(){

  if($('.timeline-container.-editable ').length){

    let isMobileDevice = isTablet();
    let $timelineTitle =$('.timeline-container.-editable .timeline-title');
    let $timelineSlide = $('.timeline-container.-editable .view__inner-container ');
    setTimeout(function () {
      let matchTimelineHeadingHeight = function(){
        $timelineTitle.matchHeight({
            byRow: false
        });
        $timelineSlide.matchHeight({
            byRow: true
        });
      }
        isMobileDevice = isTablet();
        if (!isMobileDevice) {
          matchTimelineHeadingHeight();
        }

        $('.slick-initialized').slick('refresh');

    }, 250)

    $.fn.matchHeight._afterUpdate = function(event, groups) {
      $('.timeline-container.-editable').css('opacity','1');
    }



  }

  that.$window = $(window);
  that.$window.on('resize orientationchange', debounce(function () {

    let $timelineTitle =$('.timeline-container.-editable .timeline-title');
    let $timelineSlide = $('.timeline-container.-editable .view__inner-container');
    let matchTimelineHeadingHeight = function(){
      $timelineTitle.matchHeight({
          byRow: false
      });
      $timelineSlide.matchHeight({
          byRow: true
      });
    }
      isMobileDevice = isTablet();
      if (!isMobileDevice) {
        matchTimelineHeadingHeight();
      } else{
        $timelineTitle.css('height','auto');
        $timelineSlide.css('height','auto');
      }

      $('.slick-initialized').slick('refresh');


  }, 250))


  if($('#timeline.timeline').length){

     $(".timeline").attachDragger();



     let slideTimelineToSelectDate = function(e, nextSlide){
       if(!$('.timeline__item--active').length){
         return false;
       }
        var el = $('.timeline__item--active');
        var elID = el.data('id');
        var elOffset = el.offset().left;
        var elWidth = el.width();
        var windowWidth = $(window).width();
        var offset;
        offset = elOffset ;

        var speed = 700;
        var outer = $('#timeline');
        var inner = $('.timeline__list');

        var target = $('.timeline__item--active');
        var x = outer.width();
        var y = target.outerWidth(true);
        var z = el.data('id');

        if( nextSlide !== undefined){
         z = nextSlide;
        }
        var r = (x - y) / 2;
        var s = y * z;
        var t = s - r;

        var outer2 = document.getElementById('timeline');

        TweenMax.to('#timeline.timeline', 0.3, {scrollTo:{x:t+ $(window).width()*0.5 , autoKill:false}, ease:Power2.easeInOut});
      }

    //select current slide/ tracker

    var $timelineEditable =  $('.timeline-container.-editable');
    $timelineEditable.each(function(i,ele){
      var activeEvent = $(ele).find('.timeline__item.timeline__item--active');
      if(activeEvent.length === 0){
        $(ele).find('.timeline__list li').last().addClass("timeline__item--active");
      }
    })


     slideTimelineToSelectDate();

     $(() => {
         let defaultSlickSpeed = 300;
         var $timelineEditable =  $('.timeline-container.-editable');
         $timelineEditable.each(function(i,ele){
           var activeEvent = $(ele).find('.timeline__item.timeline__item--active');
           if(activeEvent.length === 0){
             $(ele).find('.timeline__list li').last().addClass("timeline__item--active");
           }
           var $timeline = $(ele);
           var $slides = $(ele).find('.views').not('.slick-initialized');
           var $slidesInitialized = $(ele).find('.views');
           var $slideToShow = $(ele).find(".timeline__item--active").data('id');
           $slides
               .slick({
                   speed: defaultSlickSpeed,
                   initialSlide: $slideToShow,
                   fade: true,
                   infinite: false,
                   adaptiveHeight: true,
                   centerMode: true
               })
               .on('beforeChange', (evt, slick, currentSlide, nextSlide) => {
                 var $timeline = $(this);
                 var timelineLastSlide  = $timeline.find('.timeline__list').find('li:last-child').data('id');
                 if(timelineLastSlide === currentSlide){
                   return false;
                 }
                   let delta = Math.abs(currentSlide - nextSlide);
                   if(delta === slick.slideCount - 1) {
                       delta = 1;
                   }

                   let numberOfSlides = $(this).find('.slick-slide').length-1;

                   if(nextSlide === 0 ){
                     $(this).find('.slick-prev.slick-arrow').hide();
                   } else{
                     $(this).find('.slick-prev.slick-arrow').show();
                   }

                   if(nextSlide === numberOfSlides){
                     $(this).find('.slick-next.slick-arrow').hide();
                   }else{
                     $(this).find('.slick-next.slick-arrow').show();
                   }


                   slideTimelineToSelectDate(evt, nextSlide);


                   $timeline.find('.timeline__item--active').removeClass('timeline__item--active');
                   $timeline.find('.timeline__list').find('.timeline__item--active').removeClass('timeline__item--active');
                   $timeline.find(`.timeline__item[data-id=${nextSlide}]`).addClass('timeline__item--active');


               })
               .on('afterChange', (evt, slick, currentSlide) => {
                   $slides.slick('slickSetOption', 'speed', defaultSlickSpeed);

               });

               if( $(this).find('.slick-active').data('slick-index') === 0 ){
                  $(this).find('.slick-prev.slick-arrow').hide();
               }

               let numberOfSlides = $(this).find('.slick-slide').length-1;

               if( $(this).find('.slick-active').data('slick-index') === numberOfSlides ){
                  $(this).find('.slick-next.slick-arrow').hide();
               }

           $timeline.find('.timeline__link').on('click', (evt) => {
               evt.preventDefault();
               var $timeline = $(this).parent('.timeline-container.-editable');
               $slidesInitialized.slick('slickGoTo', $(evt.currentTarget).parent().prevAll('li').length);

           });
         })
      })
    }
  });
  }
}
